import { Call, Location, Time } from '../../../Assets/SVGS'
import Icon from '../../common/Icon/Icon'
import './ContactCard.css'
import { useTranslation } from 'react-i18next';
function ContactCard(){
  const { t } = useTranslation();
  return(
    <div className="contactCard-container container" >
      <div className="contactCard-content content">
        <div className="card">
          <Icon icon={<Call width="50px"/>}/>
          <div className="info">
            <h3>01111039794</h3>
            <p>atefmark369@gmail.com</p>
          </div>
        </div>
        <div className="card" onClick={()=>window.open("https://maps.app.goo.gl/ibDiAeqBXe44qmj76" , '_blank')}>
          <Icon icon={<Call width="50px"/>}/> 
          <div className="info">
            <h3>13 El Dahan, Qesm 1st</h3>
            <p>El Mahalet El Kobra, Al Gharbiyah</p>
          </div>
        </div>
        <div className="card">
          <Icon icon={<Time width="50px"/>}/>
          <div className="info">
            <h3>{t('satTue')}</h3>
            <p>{t('fridayClosed')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ContactCard